import { FormField } from '@domgen/dgx-fe-forms/layout';

export interface CmsApplianceDetailsForm {
  applianceCodeField: FormField;
  brandCodeField: FormField;
  modelNumberField: FormField;
  purchaseDateField: FormField;
  purchasePriceField: FormField;
  retailerField: FormField;
  serialNumberField: FormField;
  warrantyField: FormField;
}
